import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
    descriptionList: null,
};

// ================= FETCH TEMP USER =================
export const fetchTempUserList = createAsyncThunk(
    "fetchTempUserList",
    async (body, { rejectWithValue }) => {
        try {

            const response = await instance.get(
                `/remark/user/temp-user?page=${body.page}&search=${body.search}&platform=${body.platform}&register=${body.register}`
            );

            return response.data;

        } catch (error) {

            return rejectWithValue(error.response?.data);

        }
    }
);

// ================= DELETE USER =================
export const deleteTempUser = createAsyncThunk(
    "deleteTempUser",
    async (id, { rejectWithValue }) => {
        try {

            const response = await instance.delete(
                `/remark/user/delete-temp-user?id=${id}`
            );

            return response.data;

        } catch (error) {

            return rejectWithValue(error.response?.data);

        }
    }
);

// ================= ADD DESCRIPTION =================
export const addDescription = createAsyncThunk(
    "addDescription",
    async (body, { rejectWithValue }) => {
        try {

            const response = await instance.post(
                `/remark/user/add-descrition-temp-user`,
                body
            );

            return response.data;

        } catch (error) {

            return rejectWithValue(error.response?.data);

        }
    }
);

// ================= SLICE =================
export const TempUserSlice = createSlice({
    name: "TempUserSlice",
    initialState,
    reducers: {},

    extraReducers: (builder) => {

        // FETCH TEMP USER
        builder
            .addCase(fetchTempUserList.pending, (state) => {
                state.loading = true;
            })

            .addCase(fetchTempUserList.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.count = action.payload?.count;
            })

            .addCase(fetchTempUserList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });

        // ADD DESCRIPTION
        builder
            .addCase(addDescription.pending, (state) => {
                state.loading = true;
            })

            .addCase(addDescription.fulfilled, (state, action) => {
                state.loading = false;
                state.descriptionList = action.payload;
            })

            .addCase(addDescription.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });

        // DELETE USER
        builder
            .addCase(deleteTempUser.pending, (state) => {
                state.loading = true;
            })

            .addCase(deleteTempUser.fulfilled, (state) => {
                state.loading = false;
            })

            .addCase(deleteTempUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default TempUserSlice.reducer;